import { Box } from "@mui/material";
import type { FC } from "react";
import { DASHBOARD_TRANSITION_DURATION_MS } from "web_myplann/Dashboard/Utils/dashboardLayout";

type Props = {
	gradient: string;
	isVisible: boolean;
};

export const DashboardGradientLayer: FC<Props> = ({ gradient, isVisible }) => (
	<Box
		position="absolute"
		top={0}
		left={0}
		right={0}
		bottom={0}
		sx={{
			background: gradient,
			opacity: isVisible ? 1 : 0,
			willChange: "opacity",
			transition: `opacity ${DASHBOARD_TRANSITION_DURATION_MS}ms ease-in-out`,
		}}
	/>
);
